module.exports = __webpack_public_path__ + "static/media/maIcon.29eef2b1.svg";